import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCreditCard2"><Path d="M2.5 10V19.5H21.5V10M2.5 10V4.5H21.5V10M2.5 10H21.5M6.5 13.5H9.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCreditCard2;
